import { useContext } from 'react';
import { AnalyticsContext } from '../../ModularReduxAnalytics';
import { useUser, useUserDispatchers } from '../../state/user';
import { useApp } from '../../state/app';
import ReturningChildComplete from './index';

const ReturningChildCompleteContainer = props => {
  const { analytics } = useContext(AnalyticsContext);
  const { registeredUser, nextRegStep } = useUser();
  const { appOs } = useApp();
  const { setNextRegStep } = useUserDispatchers();

  const childProps = {
    ...props,
    analytics,
    appOs,
    nextRegStep,
    registeredUser,
    setNextRegStep
  };

  return <ReturningChildComplete {...childProps} />;
};

export default ReturningChildCompleteContainer;
